import axios from 'axios'

import {
    ALL_TEMPLATES,
    CATEGORY_TEMPLATES,
    GET_TEMPLATE_DETAIL,
    FORM_CREATED_VIA_TEMPLATE,
    FORM_VIA_TEMPLATE_AFTER_AUTH,
    SIMILAR_CATEGORY_TEMPLATES,
    ALL_TEMPLATE_USE_CASES,
    ALL_TEMPLATE_SUITABLE_FOR,
    FETCH_TEMPLATE_DETAIL_BY_SLUG,
} from '../constants/templates'

const TEMPLATE_BASE_URL = `${process.env.REACT_APP_API_URL}/feedbacks/apiv2/template`


export const getAllFeedbackFormTemplates = () => async (dispatch, getState) => {
    let headers = {
        'Content-Type': 'application/json',
    }
    try {
        let response = await axios.get(
            `${process.env.REACT_APP_API_URL}/feedbacks/apiv2/feedback-form/template-form/`,
            { headers }
        )

        if (response.status === 200) {
            dispatch({ type: ALL_TEMPLATES, data: response.data.data })
        }
    }
    catch (error) {
        throw error
    }
}

export const getTemplatesOfACategory = (data) => async (dispatch, getState) => {
    // dispatch({ type: TEMPLATES_NULL })
    let headers = {
        'Content-Type': 'application/json',
    }

    try {
        let response = await axios.get(
            `${TEMPLATE_BASE_URL}/feedback-form/category/?slug=${data}`,
            { headers }
        )

        if (response.status === 200) {
            dispatch({ type: CATEGORY_TEMPLATES, data: response.data.data })
        }
    }
    catch (error) {
        throw error
    }

}


export const getSimilarTemplatesOfACategory = (data) => async (dispatch, getState) => {
    // dispatch({ type: TEMPLATES_NULL })
    let headers = {
        'Content-Type': 'application/json',
    }
    try {
        let response = await axios.get(
            `${TEMPLATE_BASE_URL}/feedback-form/category/similar/?slug=${data}`,
            { headers }
        )

        if (response.status === 200) {
            dispatch({ type: SIMILAR_CATEGORY_TEMPLATES, data: response.data.data })
        }
    }
    catch (error) {
        throw error
    }

}

export const getTemplateFeedbackForm = data => async dispatch => {
    let headers = {
        'Content-Type': 'application/json'
    }

    try {
        let response = await axios.get(
            `${TEMPLATE_BASE_URL}/detail/?template_form_id=${data}`,
            { headers }
        )

        if (response.status === 200) {
            return dispatch({ type: GET_TEMPLATE_DETAIL, data: response.data.data })
        }
    }
    catch (error) {
        throw error
    }
}

export const createFormFromTemplate = (data) => async (dispatch, getState) => {
    const { token } = getState().auth

    if (token) {
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        }
        let response = await axios.post(
            `${TEMPLATE_BASE_URL}/create/feedback-form/`,
            data,
            { headers }
        )
        if (response.status === 200) {
            dispatch({ type: FORM_CREATED_VIA_TEMPLATE, data: response.data.data })
        }
    }
}

export const createFormFromTemplateAfterAuth = (data) => async (dispatch) => {
    dispatch({ type: FORM_VIA_TEMPLATE_AFTER_AUTH, data: data })
}



export const getAllTemplateUseCases = () => async (dispatch, getState) => {
    const token = getState().auth.token

    if (token) {
        let headers = {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        }

        try {
            let response = await axios.get(
                `${process.env.REACT_APP_API_URL}/feedbacks/apiv2/template-use-cases/`,
                { headers }
            )

            if (response.status === 200) {
                dispatch({
                    type: ALL_TEMPLATE_USE_CASES,
                    data: response.data?.data || response.data
                })
            }

        } catch (error) {
            console.error("Error fetching template use cases:", error)
            throw error
        }
    }
}

export const getAllTemplateSuitableFor = () => async (dispatch, getState) => {
    const token = getState().auth.token

    if (token) {
        let headers = {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        }

        try {
            let response = await axios.get(
                `${process.env.REACT_APP_API_URL}/feedbacks/apiv2/template-suitable-for/`,
                { headers }
            )

            if (response.status === 200) {
                dispatch({
                    type: ALL_TEMPLATE_SUITABLE_FOR,
                    data: response.data
                })
            }

        } catch (error) {
            console.error("Error fetching template suitable for:", error)
            throw error
        }
    }
}

export const getTemplateDetailBySlug = (slug) => async (dispatch, getState) => {
    const token = getState().auth.token

    if (!token) return

    const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
    }

    try {
        const response = await axios.get(
            `${process.env.REACT_APP_API_URL}/feedbacks/apiv2/template/detail/`,
            {
                headers,
                params: { template_form_id: slug }
            }
        )

        dispatch({
            type: FETCH_TEMPLATE_DETAIL_BY_SLUG,
            data: response.data?.data || response.data
        })

    } catch (error) {
        console.error("Error fetching template detail:", error)
    }
}

export const handlePublishAsTemplate = (formID) => async (dispatch, getState) => {
  const { token } = getState().auth

  if (!token) {
    throw new Error("No token found")
  }

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/feedbacks/apiv2/feedback-form/template/`,
      {
        form_id: formID,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`
        }
      }
    )

    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    throw error
  }
}